import { LmsUserStatus } from "~/LMS/LmsUserStatus";

export function getUserStatus(): LmsUserStatus {
  return (window.SCHA?.user?.lmsState ?? LmsUserStatus.Guest) as LmsUserStatus;
}

export function setUserStatus(lmsState: string) {
  window.SCHA.user.lmsState = lmsState;
}
